enum actionTypes {
    MODAL_UTILIZAR_VOCHER_OPEN = 'MODAL_UTILIZAR_VOCHER_OPEN',
    MODAL_UTILIZAR_VOCHER_CLOSE = 'MODAL_UTILIZAR_VOCHER_CLOSE'
}

export default actionTypes;
